import * as React from 'react'

import { useAppDispatch } from 'redux/store'
import { PopupId, showSoundscapeDemoPopup } from 'redux/popupReducer'
import { SolutionsGrid } from 'components/solutions-grid/SolutionsGrid'

import type { SoundscapeSolutionsCmsContent } from 'core/services/cms/interfaces'

interface SolutionsProps {
  content: SoundscapeSolutionsCmsContent
}

const SOUNDSCAPE_POPUP_IDS = [
  PopupId.SoundscapeFeel,
  PopupId.SoundscapeSmart,
  PopupId.SoundscapeZone,
  PopupId.SoundscapeVoice,
  PopupId.SoundscapeSafe,
]

export const Solutions: React.FC<SolutionsProps> = ({ content }) => {
  const dispatch = useAppDispatch()
  const solutions = content.items.map((item, index) => ({
    logo: item.logoUrl,
    bg: item.backgroundImageUrl,
    description: item.description,
    popupId: SOUNDSCAPE_POPUP_IDS[index],
    popupContent: {
      logoUrl: item.logoUrl,
      title: item.popupTitle,
      description: item.popupDescription,
    },
  }))

  return (
    <SolutionsGrid
      title={content.title}
      solutions={solutions}
      onSolutionClick={(solution) => {
        if (solution.popupId && solution.popupContent) {
          dispatch(showSoundscapeDemoPopup({
            popupId: solution.popupId,
            content: solution.popupContent,
          }))
        }
      }}
    />
  )
}
